import { Injectable, inject } from '@angular/core';
import { Auth, onAuthStateChanged } from 'firebase/auth';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Observable, first, map } from 'rxjs';
import { FIREBASE_AUTH } from '../firebase.tokens';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  private auth: Auth = inject(FIREBASE_AUTH);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.secure();
  }
  canActivateChild(): Observable<boolean> {
    return this.secure();
  }
  private secure(): Observable<boolean> {
    return new Observable((subscriber) =>
      onAuthStateChanged(
        this.auth,
        (user) => subscriber.next(user),
        (err) => subscriber.error(err),
      ),
    ).pipe(
      first(),
      map((user) => {
        if (!user) {
          this.router.navigateByUrl('/login');
          return false;
        } else {
          return true;
        }
      }),
    );
  }
}
